
import React, { useState } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

interface ClearCanvasDialogProps {
  onClear: () => void;
  hasUnsavedChanges?: boolean;
  trigger: React.ReactNode;
}

export const ClearCanvasDialog = ({
  onClear,
  hasUnsavedChanges = false,
  trigger,
}: ClearCanvasDialogProps) => {
  const [open, setOpen] = useState(false);

  const handleClear = (e: React.MouseEvent) => {
    // Prevent event bubbling
    e.preventDefault();
    e.stopPropagation();
    
    console.log('ClearCanvasDialog: Clear button clicked - calling onClear function');
    
    // Make sure onClear is called directly
    if (typeof onClear === 'function') {
      onClear();
    } else {
      console.error('ClearCanvasDialog: onClear is not a function', onClear);
    }
    
    // Close the dialog after clearing
    setOpen(false);
  };
  
  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        {trigger}
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Clear Canvas</AlertDialogTitle>
          <AlertDialogDescription>
            {hasUnsavedChanges 
              ? "You have unsaved changes. Are you sure you want to clear the entire canvas?"
              : "Are you sure you want to clear the entire canvas? This action cannot be undone."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleClear}>
            Clear Canvas
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
